import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { LayoutService } from 'src/app/services/layout.service';
import { NavService } from 'src/app/services/nav.service';
import { MessageInboxItem, MeyMessageInboxClient, UserProfile } from 'src/app/web-api-client';
import { WtStorageService } from 'src/app/wt-storage.service'; 
import { ReadMailComponent } from '../../mails/read-mail/read-mail.component';

@Component({
  selector: 'app-anona-header',
  templateUrl: './anona-header.component.html',
  styleUrls: ['./anona-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnonaHeaderComponent implements OnInit {
  public dark: boolean =
    this.layout.config.settings.layout_version == 'dark-only' ? true : false;

    public userProfile:UserProfile;
  collapseSidebar: boolean = true;
  public isLoaded: boolean = false;
  public mailInbox: MessageInboxItem[] = [];


  constructor(
    private navServices: NavService,
    public layout: LayoutService,
    public authService: AuthService,
    public notificationService:MeyMessageInboxClient,
    public localCahce: WtStorageService,
    public changeDetectionRef: ChangeDetectorRef, 
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
     

   
     

  } 

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  layoutToggle() {
    this.document.body.classList.toggle('dark-only');
  }
  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }
  searchToggle() {
    this.navServices.search = true;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const element = document.getElementById('sidebar-toggle');
    if (element && window.innerWidth > 1199) {
      element.style.display = 'none';
    } else if (element) {
      element.style.display = 'block';
    }

    this.changeDetectionRef.detectChanges();
  }
   

}
